import React, { useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import useScrollRestoration from 'app/hook/common/useScrollRestoration';
import Layout from 'app/components/common/Layout';
import HeadInfo from 'app/components/common/HeadInfo';
import Button from 'app/components/common/Button';
import AlignBox from 'app/components/common/AlignBox';
import DiagnosisIntroStatic from 'app/statics/diagnosis/DiagnosisIntroStatic';
import useGoSearchList from 'app/hook/searchList/useGoSearchList';
import { RYVUSS_SEARCH_PARAM } from '@encarpkg/shared';

const DiagnosisIntroPage = () => {
	const { goSearchList } = useGoSearchList();
	const history = useHistory();

	const handleClick = () => {
		const nav = {
			type: 'car',
			action: RYVUSS_SEARCH_PARAM.action.국산수입_엔카진단,
			toggle: {},
			layer: '',
			sort: RYVUSS_SEARCH_PARAM.sort.최근_업데이트순,
		};
		goSearchList(nav);
	};
	const { storeScroll, restoreScroll } = useScrollRestoration();
	const handelStoreScroll = useCallback(() => {
		storeScroll();
		history.push('/diagnosis/check-guide');
	}, [storeScroll, history]);
	useEffect(() => {
		restoreScroll();
	}, [restoreScroll]);
	return (
		<>
			<Layout
				title="엔카진단"
				usePrevBtn
				useSSR
				enlogConfig={{
					dataTalkView: {
						screenname: '진단홈',
					},
				}}
			>
				<HeadInfo
					headTitle="엔카진단"
					metaDescription="중고차 사고팔땐 엔카, 중고차, 중고차매매사이트, 중고차시세, 엔카 진단차, 무사고 진단차"
				/>
				<DiagnosisIntroStatic />
				<AlignBox
					type="float"
					fixed
				>
					<Button
						domType="button"
						title="진단차량 확인 방법"
						color="white"
						onClick={handelStoreScroll}
					/>
					<Button
						onClick={handleClick}
						title="진단차량 보러가기"
					/>
				</AlignBox>
			</Layout>
		</>
	);
};

export default DiagnosisIntroPage;
